export default {
  appName: window.env.GOOGLE_ANALITYCS_NAME, // Mandatory
  appVersion: process.env.PACKAGE_VERSION || '0', // Mandatory
  trackingId: window.env.GOOGLE_ANALITYCS_UA, // Mandatory
  debug: process.env.NODE_ENV !== 'production' // Whether or not display console logs debugs (optional)
}
